/*
 * Fig & Bloom — keep the Delivery Date App's ATC payload on the size the PDP shows.
 *
 * processCartAdditionEnhanced maps window.selectedVariants with no form fallback.
 * The app's headerDeliveryForm / delivery-date-extension.js seed that array from
 * selected_or_first_available (Gesture on the ladder). The theme header snippet
 * that used to overwrite it only renders on collection and index, so a cold-load
 * ATC on /products/osaka submitted Gesture under a Signature pill.
 *
 * This file is the product-rendered path. It replaces the array from the live
 * buy-button form (SSR Signature, or Gesture after the location filter moves
 * the pill) and does it again in capture phase on ATC so a later deferred
 * app hard-set cannot win.
 *
 * The same array carries the add-ons picked in the app's upsell rows (greeting
 * card, vase), and the app adds everything in it in one /cart/add.js call. Only
 * the main variant is replaced here; cards the shopper has selected (.selected)
 * stay in the payload. Replacing the whole array dropped them from every PDP
 * add to cart.
 */
(function () {
  if (window.__fbPdpSelectedVariantSync) return;
  window.__fbPdpSelectedVariantSync = true;

  function formInput() {
    return document.querySelector(
      '.product_buy_button_form form[data-type="add-to-cart-form"] input[name="id"]'
    ) || document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  }

  function selectedAddOnIds() {
    if (!document.querySelectorAll) return [];
    var cards = document.querySelectorAll(
      '.upsell-slider-wrapper .product-card-upsell-slider.selected[data-product-variant]'
    );
    var ids = [];
    Array.prototype.forEach.call(cards, function (card) {
      var id = parseInt(card.getAttribute('data-product-variant'), 10);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function setMainVariant(id) {
    var ids = [id];
    selectedAddOnIds().forEach(function (addOn) {
      if (ids.indexOf(addOn) === -1) ids.push(addOn);
    });
    window.selectedVariants = ids;
    window.mainORSelectedVariant = id;
  }
  window.fbSetMainVariant = setMainVariant;

  function sync(fromForm) {
    var input = fromForm
      ? fromForm.querySelector('input[name="id"]')
      : formInput();
    if (!input || !input.value) return;
    var id = parseInt(input.value, 10);
    if (!id) return;
    setMainVariant(id);
  }

  function formForEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    var form = target.closest('form[data-type="add-to-cart-form"]')
      || target.closest('product-form');
    if (form && form.querySelector && form.querySelector('input[name="id"]')) return form;
    if (target.closest('[name="add"], .product__add__cart__button, .product-form__submit')) {
      var input = formInput();
      return input && input.form ? input.form : null;
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var form = formForEvent(event);
    if (form) sync(form);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('input[name="id"]')) sync(event.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
  window.addEventListener('load', function () { sync(); });
})();
